import { render, staticRenderFns } from "./new-scan.vue?vue&type=template&id=0bdace9b&scoped=true&"
import script from "./new-scan.vue?vue&type=script&lang=js&"
export * from "./new-scan.vue?vue&type=script&lang=js&"
import style0 from "./new-scan.vue?vue&type=style&index=0&id=0bdace9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdace9b",
  null
  
)

export default component.exports